import { parse } from 'date-fns';

export const getYMDStringFromDateObject = (date: Date | null): string => {
    if (!date) return '';

    const year = date.getFullYear();
    const month = padLeft('00', date.getMonth() + 1);
    const day = padLeft('00', date.getDate());

    return `${year}-${month}-${day}`;
};

const padLeft = (padString: string, str: string | number) => (padString + str).slice(-padString.length);

export const getDateObjectFromYMD = (dateOfLoss: string): Date => {
    if (!dateOfLoss) {
        return new Date();
    }
    return parse(dateOfLoss, 'yyyy-MM-dd', Date.now());
};

// export const dateOffset = (offset: string) => {
//     const now = new Date();
//     const offsettedDate = dateFormat(now.setDate(now.getDate() - offset));

//     return offsettedDate;
// };

export const dateFormat = (date: string) => {
    const d = new Date(date);
    const year = d.getFullYear();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }
    return [year, month, day].join('-');
};

/**
 * Gets todays date formatted as dd-mm-yyyy.
 * E.g. 16th of April 2024 => '16-04-2004'
 */
export const getTodaysDateDKFormattedWithDashes = (): string => {
    return new Date()
        .toLocaleDateString('da-DK', { year: 'numeric', month: '2-digit', day: '2-digit' })
        .replaceAll('.', '-');
};

export const isoDateToEpoch = (timestamp: string) => {
    const date = new Date(timestamp);
    return date.getTime();
};

/**
 * Returns the localized name of the day for a given date, capitalized.
 *
 * @param date - The date object for which to retrieve the day name.
 * @param locale - Optional. The locale string to use for localization (default is 'da-DK').
 * @returns The localized, capitalized name of the day (e.g., "Mandag" for Danish locale).
 */
export const getLocalizedNameOfDay = (date: Date, locale: string = 'da-DK'): string => {
    const nameOfDay = date.toLocaleDateString(locale, { weekday: 'long' });

    // Capitalize the first letter of the day name
    return String(nameOfDay).charAt(0).toUpperCase() + String(nameOfDay).slice(1);
};
